import { useNavigate } from "react-router-dom";

export default function CommunitySection() {
  const navigate = useNavigate();

  return (
    <div className="bg-orange-500 py-12 px-6 md:px-20 text-white">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        {/* Left Section */}
        <div>
          <h2 className="text-2xl md:text-3xl font-bold mb-4">
            Join Our Growing Community
          </h2>
          <p className="text-sm md:text-base mb-8 text-white/90 max-w-md">
            Whether you're a service provider or someone looking for great local
            experiences, our platform connects you with opportunities that
            matter.
          </p>

          {/* Stats Grid */}
          <div className="grid grid-cols-2 gap-4 mb-6">
            <div className="bg-orange-400 p-4 rounded-lg">
              <h3 className="text-lg font-semibold">50K+</h3>
              <p className="text-sm text-white/90">Active Users</p>
            </div>
            <div className="bg-orange-400 p-4 rounded-lg">
              <h3 className="text-lg font-semibold">10K+</h3>
              <p className="text-sm text-white/90">Service Providers</p>
            </div>
            <div className="bg-orange-400 p-4 rounded-lg">
              <h3 className="text-lg font-semibold">100K+</h3>
              <p className="text-sm text-white/90">Bookings Made</p>
            </div>
            <div className="bg-orange-400 p-4 rounded-lg">
              <h3 className="text-lg font-semibold">4.8/5</h3>
              <p className="text-sm text-white/90">User Rating</p>
            </div>
          </div>

          {/* Buttons */}
          <div className="flex gap-4">
            <button
              className="bg-white text-orange-500 font-medium px-4 py-2 rounded hover:bg-orange-100 transition"
              onClick={() => navigate("/Register")}
            >
              Become a Provider →
            </button>
            <button
              className="bg-orange-600 hover:bg-orange-700 text-white px-4 py-2 rounded transition"
              onClick={() => navigate("/Register")}
            >
              Join as User
            </button>
          </div>
        </div>

        {/* Right Section: Image */}
        <div>
          <img
            src="/communitysection.jpeg"
            alt="Community members celebrating"
            className="rounded-lg shadow-lg w-full object-cover"
          />
        </div>
      </div>
    </div>
  );
}
